import moment from "moment";
import React from "react"

export const versionControlColumn = ({ onView, onEdit } = {}) => [
  {
    Header: "Date",
    accessor: "date",
    className: "text-center col-md-1 ",
    Cell: ({ row }) => {
      return(
        <div>{moment(row?.original?.date)?.format('DD-MM-YYYY')}</div>
      )
    }
  },
  {
    Header: "Update Type",
    accessor: "versionType",
    className: "text-center col-md-1",
    Cell: ({ value }) => {
      if (value === "new module") return "New Module";
      if (value === "updation") return "Updation";
      if (value === "bug fix") return "Bug Fix";
      return value;
    }
  },  
  {
    Header: "Version",
    accessor: "version",
    className: "text-center col-md-1",
  },
  {
    Header: "Description",
    accessor: "description",
    className: "col-md-7",
    Cell: ({ value }) => {
      const wordLimit = 10;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = value || "";
      const textOnly = tempDiv.textContent || tempDiv.innerText || "";
  
      const truncated =
        textOnly.split(" ").length > wordLimit
          ? textOnly.split(" ").slice(0, wordLimit).join(" ") + "..."
          : textOnly;
  
      return (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          dangerouslySetInnerHTML={{ __html: truncated }}
        />
      );
    },
  },  
  {
    Header: "Action",
    accessor: "action",
    className: "text-center col-md-1",
    Cell: ({ row }) => (
      <div className="d-flex justify-content-center">
        <button
          className="btn btn-sm btn-outline-secondary me-1"
          title="View"
          onClick={() => onView(row.original)}
        >
          <i className="bi bi-eye-fill" />
        </button>
        <button
          className="btn btn-sm btn-outline-secondary me-1"
          title="Edit"
          onClick={() => onEdit(row.original)}
        >
          <i className="bi bi-pencil-fill" />
        </button>
      </div>
    ),
  },
]